import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createSimulationPreset, deleteSimulationPreset, getSimulationPreset, querySimulationPresets, updateSimulationPreset } from '@wix/ambassador-individual-scheduling-assistant-v1-simulation-preset/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { SimulationPresetClientBase } from './SimulationPresetClientBase';
export class SimulationPresetClient extends HttpBaseClient(SimulationPresetClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createSimulationPresetImpl", createSimulationPreset);
    _defineProperty(this, "getSimulationPresetImpl", getSimulationPreset);
    _defineProperty(this, "updateSimulationPresetImpl", updateSimulationPreset);
    _defineProperty(this, "deleteSimulationPresetImpl", deleteSimulationPreset);
    _defineProperty(this, "querySimulationPresetsImpl", querySimulationPresets);
  }
}
//# sourceMappingURL=SimulationPresetClientHttp.js.map